import Vue from 'vue'
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import store from './store/index'
import { getQueryVariable } from "@/utils";
import { getToken } from '@/api/public';
import constants from "@/utils/constants";
// import sensors from 'sa-sdk-javascript';

function linkLogin() {
    window.location.href = `${constants.VUE_APP_AUTH_URL}/oauth/authorize?response_type=code&client_id=100002&redirect_uri=${window.location.origin}`;
}

console.log("NODE_ENV",process.env.NODE_ENV)
if(process.env.NODE_ENV==='development'){
    // sensors.init({
    //     heatmap_url: 'https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.14.18/heatmap.min.js',
    //     name: 'sensors',
    //     // server_url: 'http://scs.smartservice.bjev.com.cn/sa',
    //     server_url: '',
    //     is_track_single_page:true,
    //     scrollmap:{
    //         collect_url:true,
    //     },
    //     heatmap:{
    //         clickmap:'default',
    //         loadTimeout:  3000,
    //         scroll_notice_map:'default',
    //         show_log:false,
    //         scroll_delay_time: 4000,
    //         scroll_event_duration: 18000,
    //         renderRefreshTime:1000,
    //     }
    // });
}

NProgress.configure({showSpinner: false}) // NProgress Configuration
router.beforeEach(async(to, from, next) => {
    NProgress.start();
    document.title = to.meta.title;
    console.log("router.beforeEach",to)
    var permission = store.getters.permission;
    // if (to.path.indexOf('questionnaire') !=-1) {
    //     next()
    //     NProgress.done();
    // } else {
        const code = getQueryVariable('code'); 
         if (code && code !== sessionStorage.getItem('code')) {
            sessionStorage.setItem('code', code); 
            // 登录成功返回新的code，code不同重新获取token
            const data = await getToken(code);
            console.log('===data==>',data)
            sessionStorage.setItem('code', code);
            localStorage.token = data.accessToken;
            localStorage.uid = data.yyUserId;
            const imUser = {
                imUserId: data.imUserId || ''
            }
            window.localStorage.setItem("imUser", JSON.stringify(imUser));
            next(to.fullPath);
        }
        else if (!code && !localStorage.token) {
            linkLogin();
        }else if (localStorage.token) {
            if (to.path === '/login') {
                document.title = '用户登录';
                next({path: '/'});
                NProgress.done();
            } else {
                if (permission.length === 0) {
                    store.dispatch("GetPermission").then(res => {
                        permission = res;
                        if (!to.meta.permission) {
                            next();
                        } else if (permission.includes(to.meta.permission)) {
                            next();
                        } else {
                            document.title = '403 无法访问权限';
                            next({path: '/exception/403'});
                        }
                    });
                } else {
                    if (!to.meta.permission) {
                        next();
                    }
                    else if (permission.includes(to.meta.permission)) {
                        next();
                    } else {
                        document.title = '403 无法访问权限';
                        next({path: '/exception/403'});
                    }
                }
            }
        }
        // else {
        //     if (to.path === '/login') {
        //         next();
        //     } else {
        //         document.title = '用户登录';
        //         next({path: '/login', query: {redirect: to.fullPath}});
        //     }
        //     NProgress.done();
        // }
        if(process.env.NODE_ENV==='development'){
            // sensors.quick("autoTrackSinglePage")
        }
    // }
});

router.afterEach(() => {
    NProgress.done() // finish progress bar
});
